import {
  GET_ROUTE,
  GET_FULL_TRIP_ROUTE
} from '../actionTypes';
import {
  PENDING,
  SUCCESS,
  FAILURE
} from '../../utils/status';

import * as routeService from '../../services/route';
import * as tripHelper from '../../helpers/trip';

let ROUTE_CACHE = {};
// 已被取消的 Promise 对象
let invalidPromise = Promise.resolve(true);
invalidPromise.cancel();
export function getRoute(poi_uids, trip_id) {
  return function (dispatch, getState) {
    if (poi_uids.split(',').length < 2) {
      // 不用请求了，没有路线
      return dispatch({
        type: GET_ROUTE,
        status: SUCCESS,
        data: {}
      });
    }

    dispatch({
      type: GET_ROUTE,
      status: PENDING
    });

    // 做缓存
    let key = `${trip_id}-${poi_uids}`;
    if(ROUTE_CACHE[key]){
      let data = ROUTE_CACHE[key];
      dispatch({
        type: GET_ROUTE,
        status: SUCCESS,
        data: data
      });
      return data;
    }

   
    // 请求第一页，取消上一次请求
    if (getRoute.promise) {
      getRoute.promise.cancel();
      getRoute.promise = null;
      // 理论上还应该
      // dispatch(CANCEL)
    }

    getRoute.promise = routeService.getRouteByPoiUids(poi_uids, trip_id)
      .then(function (data) {
        dispatch({
          type: GET_ROUTE,
          status: SUCCESS,
          data: data
        });

        if(!ROUTE_CACHE[key]){
          ROUTE_CACHE[key] = data;
        }

        return data;
      })
      .catch(function (err) {
        dispatch({
          type: GET_ROUTE,
          status: FAILURE,
          data: err
        });

        return err;
      });

    return getRoute.promise;
  };
}


export function getDayTripRoute(trip, day) {
  let pois;
  if (day === 0) {
    pois = tripHelper.getCities(trip);
  } else {
    pois = tripHelper.getPoisOfDayTrip(trip, day);
  }

  let poi_uids = pois.map(function (poi) {
    return poi.poi_uid;
  }).join(',');

  return getRoute(poi_uids, trip.trip_id);
}

export function getFullTripRoute(trip) {
  return function (dispatch) {
    let poi_uids = tripHelper.getPois(trip)
      .map(function (poi) {
        return poi.poi_uid;
      });

    if (poi_uids.length < 2) {
      // 不用请求了，没有路线
      return dispatch({
        type: GET_ROUTE,
        status: SUCCESS,
        data: {}
      });
    }

    dispatch({
      type: GET_FULL_TRIP_ROUTE,
      status: PENDING
    });

    poi_uids = poi_uids.join(',');
    // 做缓存
    let key = `${trip.trip_id}-${poi_uids}`;
    if(ROUTE_CACHE[key]){
      let data = ROUTE_CACHE[key];
      dispatch({
        type: GET_ROUTE,
        status: SUCCESS,
        data: data
      });
      return data;
    }

    // 请求第一页，取消上一次请求
    if (getFullTripRoute.promise) {
      getFullTripRoute.promise.cancel();
      getFullTripRoute.promise = null;
      // 理论上还应该
      // dispatch(CANCEL)
    }

    getFullTripRoute.promise = routeService.getRouteByPoiUids(poi_uids, trip.trip_id)
      .then(function (data) {
        dispatch({
          type: GET_FULL_TRIP_ROUTE,
          status: SUCCESS,
          data: data
        });
        if(!ROUTE_CACHE[key]){
          ROUTE_CACHE[key] = data;
        }
        return data;
      })
      .catch(function (err) {
        dispatch({
          type: GET_FULL_TRIP_ROUTE,
          status: FAILURE,
          data: err
        });

        throw err;
      });

    return getFullTripRoute.promise;
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/route.js